import {computed, reactive, readonly} from "vue";
import {webDeskGet} from "@/services/webdesk/webDeskFetch";

export interface CompanyInterface {
    name: string;
    street: string;
    postcode: string;
    city: string;
    nip: string;
}

export type WebDeskApp = {
    object_name: string;
    company?: CompanyInterface;
    phone: string;
    email: string;
    token: string;
    code?: string,
    reservation_number: string;
    to_pay: {
        installment: number;
        total: number;
    };
    total: number;
    bookings: number;
    lang: string;
    is_checkin: boolean;
    is_checkout: boolean;
    checked_out:boolean;
    assistant_module: boolean;
}

let app: WebDeskApp = {
    object_name: '',
    company: undefined,
    phone: '',
    email: '',
    token: '',
    reservation_number: '',
    to_pay: {
        installment: 0,
        total: 0,
    },
    total: 0,
    bookings: 0,
    lang: 'pl',
    is_checkin: false,
    is_checkout: false,
    checked_out: false,
    assistant_module: false
};

export type WebDeskAppAccessStatus = {
    access: boolean;
    message?: string;
}

export const WebDeskAppStore = reactive({
    app: readonly(app),
    waitForToken(): Promise<void> {
        return new Promise(resolve => {
            const interval = setInterval(() => {
                if (app.token) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });
    },
    async fetch(token: string, code?: string, lang?: string) {
        if (!app.token) {
            app.token = token;
            app.code = code?.toUpperCase();
            app.lang = lang || 'pl';
            await WebDeskAppStore.refresh();
        }
    },
    async refresh() {
        app = await webDeskGet('welcome', undefined, false);
        console.log(app);
        WebDeskAppStore.app = readonly(app);
    },
    async checkAccess(): Promise<WebDeskAppAccessStatus> {
        return await webDeskGet('welcome/access_status');
    },
    reset() {
        app = {
            object_name: '',
            token: '',
            company: undefined,
            phone: '',
            email: '',
            reservation_number: '',
            to_pay: {
                installment: 0,
                total: 0,
            },
            total: 0,
            bookings: 0,
            lang: 'pl',
            is_checkin: false,
            is_checkout: false,
            checked_out: false,
            assistant_module: false
        };
        WebDeskAppStore.app = readonly(app);
    }
});
